<!--Main-->
<template>
  <div class="table-content" :class="className" v-if="data">
    <!-- 显示表格 -->
    <el-table
      ref="multipleTable"
      :key="tableKey"
      v-loading="listInfo.loading"
      :height="tableHeight || undefined"
      :data="data"
      :row-key="handle && handle.rowKey || 'id'"
      :span-method="handle && handle.spanMethod"
      :tree-props="handle && handle.treeProps"
      :expand-row-keys="handle && handle.expandRowKeys"
      :border="handle && typeof handle.border !== 'undefined' ? handle.border : true"
      style="width: 100%"
      element-loading-text="Loading"
      fit
      size="mini"
      highlight-current-row
      @select-all="handleSelectionChange"
      @select="handleSelectionChange"
    >
      <template v-for="(item, index) in fieldList">
        <template v-if="item.show">
          <!-- 多选框按钮 -->
          <el-table-column
            v-if="item.btType == 'selection'"
            :prop="item.prop"
            :key="index"
            type="selection"
            width="55"
          />
          <!-- 多选框按钮 -->
          <el-table-column
            v-else-if="item.btType == 'treeSelection'"
            :key="index"
            type="selection"
            align="center"
            width="45"
          >
            <!-- 树形多选框按钮 -->
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row[item.prop]" :indeterminate="scope.row[item.indeterminate]" @change="() => handleEvent(item.event, scope.row)" />
            </template>
          </el-table-column>
          <!-- 层级按钮 -->
          <el-table-column
            v-else-if="item.btType == 'flags'"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
          >
            <template slot-scope="scope">
              {{ scope.row[item.prop] }}
            </template>
          </el-table-column>
          <!-- 图标按钮 -->
          <el-table-column
            v-else-if="item.btType == 'actions'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <template v-for="(bt, i) in handle.btList">
                <el-tooltip
                  v-if="(bt.show === undefined ? true : bt.show) && (!data[scope.$index].btns || (data[scope.$index].btns && data[scope.$index].btns[i] !== false)) && bt.type != 'alarm'"
                  :key="i"
                  :content="(scope.row.labels && scope.row.labels[i]) || $t(bt.label)"
                  :disabled="
                    scope.row.btns &&
                    scope.row.btns[i] &&
                    scope.row.btns[i].disabled
                  "
                  placement="bottom-start"
                >
                  <el-link
                    :icon="(scope.row.icons && scope.row.icons[i]) || bt.icon"
                    :style="`margin-left: 3px;${bt.style};
                      scope.row.btns &&
                      scope.row.btns[i] &&
                      scope.row.btns[i].disabled
                        ? 'color: #888;'
                        : ''
                    }`"
                    :class="(scope.row.classes && scope.row.classes[i]) || scope.row.btns &&
                      scope.row.btns[i] &&
                      scope.row.btns[i].disabled ? '' : 'blueLink'"
                    :underline="false"
                    :disabled="
                      scope.row.btns &&
                      scope.row.btns[i] &&
                      scope.row.btns[i].disabled
                    "
                    @click="handleClick(bt.event, scope.row)"
                  ><svg-icon v-if="bt.iconType" :icon-class="bt.icon"/></el-link>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>

          <!-- 链接按钮 -->
          <el-table-column
            v-else-if="item.btType == 'link'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >

            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleClick(item.event, scope.row)"
                >{{ scope.row[item.prop] }}</el-link
              >
            </template>
          </el-table-column>
          <!-- 链接按钮组 -->
          <el-table-column
            v-else-if="item.btType == 'links'"
            :key="index"
            :prop="item.prop"
            :label="$t(item.label)"
            :fixed="item.fixed"
            :type="item.type"
            :width="item.width"
            :min-width="item.minWidth || '100px'"
            :formatter="item.formatter"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                v-for="(linkItem, linkIndex) in scope.row.linkList"
                :key="linkIndex"
                type="primary"
                :underline="false"
                class="blueLink"
                @click="handleClick(item.event, { ...scope.row, linkIndex })"
                >{{ linkItem
                }}<span
                  v-if="
                    scope.row.linkList.length > 1 &&
                    linkIndex < scope.row.linkList.length - 1
                  "
                  >,</span
                ></el-link
              >
            </template>
          </el-table-column>
          <!-- 自定义列 -->
          <el-table-column
            v-else-if="item.btType === 'custom'"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            :type="item.type"
            show-overflow-tooltip
            :width="item.width"
          >
            <template slot-scope="scope">
              <slot name="custom-column" :scope="scope" />
            </template>
          </el-table-column>
          <template v-else>
            <el-table-column :align="item.align ? item.align : 'left'"
              v-if="item.type == 'subTitle'"
              :key="index"
              :prop="item.prop"
              :label="$t(item.label)"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            >
              <template v-for="(subItem, subIndex) in item.subFieldList">
                <el-table-column
                  :style="'background-color: #97a8be;'"
                  :align="subItem.align ? subItem.align : 'left'"
                  :key="subIndex"
                  :prop="subItem.prop"
                  :label="$t(subItem.label)"
                  :fixed="subItem.fixed"
                  :type="subItem.type"
                  :width="subItem.width"
                  :min-width="subItem.minWidth || '100px'"
                  :formatter="subItem.formatter"
                  show-overflow-tooltip
                />
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item.type == 'index'"
              :key="index"
              :prop="item.prop"
              :label="$t(item.label)"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            />
            <el-table-column
              v-else
              :key="index"
              :prop="item.prop"
              :label="$t(item.label)"
              :fixed="item.fixed"
              :type="item.type"
              :width="item.width"
              :min-width="item.minWidth || '100px'"
              :formatter="item.formatter"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span
                  :style="`color: ${
                    scope.row[item.prop + 'ShowColor'] &&
                    (item.color || scope.row[item.prop + 'Color'])
                  };`"
                  >{{ scope.row[item.prop] }}</span
                >
              </template>
            </el-table-column>
          </template>
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "Main",
  props: {
    // table实例
    refObj: {
      type: Object
    },
    // 自定义类名
    className: {
      type: String,
    },
    // 类型列表
    listTypeInfo: {
      type: Object,
    },
    // 表格字段配置
    fieldList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 操作栏配置
    handle: {
      type: Object,
    },
    // 列表数据
    data: {
      type: Array,
    },
    //table标识
    tableKey: {
      type: Number,
    },
    // 监听高度
    height: {
      type: Number,
      default: 500,
    },
    contentHeight: {
      type: Number,
      default: 550,
    },
    toggleRowSelections: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      // 列表相关
      listInfo: {
        loading: false, // 加载动画
      },
      tableHeight: 0,
    };
  },
  watch: {
    // height(value) {
    //   console.log('=============height(value)====================', value);
    //   const navH = document.getElementsByClassName("navbar")[0]
    //     ? document.getElementsByClassName("navbar")[0].clientHeight
    //     : 0;
    //   const tagH = document.getElementsByClassName("tags-view-container")[0]
    //     ? document.getElementsByClassName("tags-view-container")[0].clientHeight
    //     : 0;
    //   const searchH = document.getElementsByClassName(
    //     "fn-layout-vertical-form"
    //   )[0]
    //     ? document.getElementsByClassName("fn-layout-vertical-form")[0]
    //         .clientHeight
    //     : 0;
    //   const pagerH = document.getElementsByClassName(
    //     "fn-layout-vertical-operation"
    //   )[0]
    //     ? document.getElementsByClassName("fn-layout-vertical-operation")[0]
    //         .clientHeight
    //     : 0;
    //   const bottomH = document.getElementsByClassName(
    //     "fn-layout-vertical-pagination"
    //   )[0]
    //     ? document.getElementsByClassName("fn-layout-vertical-pagination")[0]
    //         .clientHeight
    //     : 0;
    //   const customHeader = document.getElementsByClassName(
    //     "table-custom-header "
    //   )[0]
    //     ? document.getElementsByClassName("table-custom-header ")[0]
    //         .clientHeight
    //     : 0;
    //   // if (value) {
    //   //   this.tableHeight = value;
    //   // } else {
    //   //   this.tableHeight =
    //   //     window.innerHeight -
    //   //     (navH + tagH + searchH + pagerH + bottomH + customHeader);
    //   // }
    //
    //   this.tableHeight =
    //     window.innerHeight -
    //     (navH + tagH + searchH + pagerH + bottomH + customHeader);
    //   console.log('===============this.tableHeight=====33============', this.tableHeight);
    // },
    contentHeight(value) {
      console.log('============contentHeight(value)====================', value);
      const navH = document.getElementsByClassName("navbar")[0]
        ? document.getElementsByClassName("navbar")[0].clientHeight
        : 0;

      const tagH = document.getElementsByClassName("tags-view-container")[0]
        ? document.getElementsByClassName("tags-view-container")[0].clientHeight
        : 0;
      const searchH = document.getElementsByClassName(
        "fn-layout-vertical-form"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-form")[0]
            .clientHeight
        : 0;
      const pagerH = document.getElementsByClassName(
        "fn-layout-vertical-operation"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-operation")[0]
            .clientHeight
        : 0;
      const bottomH = document.getElementsByClassName(
        "fn-layout-vertical-pagination"
      )[0]
        ? document.getElementsByClassName("fn-layout-vertical-pagination")[0]
            .clientHeight
        : 0;

      const tabH = document.getElementsByClassName("el-tabs__header")[0]
        ? document.getElementsByClassName("el-tabs__header")[0].clientHeight
        : 0;
      console.log('===============this.tableHeight=========tabH========', tabH);
      const customHeader = document.getElementsByClassName(
        "table-custom-header "
      )[0]
        ? document.getElementsByClassName("table-custom-header ")[0]
            .clientHeight
        : 0;
       // if (value) {
       //   this.tableHeight = value;
       // } else{
       //   this.tableHeight =
       //     window.innerHeight -
       //     (navH + tagH + searchH + pagerH + bottomH + tabH + customHeader + 75);
       // }
      this.tableHeight =
        window.innerHeight -
        (navH + tagH + searchH + pagerH + bottomH + tabH + customHeader + 85);
      console.log('===============this.tableHeight=================', this.tableHeight);
    },
    //toggleRowSelections
    data: {
      handler: function (val) {
        this.$emit("update:refObj", this.$refs.multipleTable);
        this.$nextTick(() => {
          this.toggleRowData();
        });
      },
      deep: true, // 深度监听
    },
    // toggleRowSelections: {
    //   handler: function (val) {
    //     alert('深度')
    //     this.$emit('update:refObj', this.$refs.table)
    //   },
    //   deep: true // 深度监听
    // },
  },
  mounted() {
    this.$emit("update:refObj", this.$refs.multipleTable);
    this.toggleRowData();
  },
  methods: {
    handleSizeChange(val) {
      const query = this.listInfo.query;
      query.pageSize = val; // 每页条数
      query.curPage = 1; // 每页条数切换，重置当前页
    },
    handleCurrentChange(val) {
      this.listInfo.query.curPage = val; // 当前页
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    // 派发按钮自定义事件
    handleEvent(event, data) {
      this.$emit("update:refObj", this.$refs.multipleTable);
      this.$emit("handleEvent", event, data);
    },
    // 选中数据
    handleSelectionChange(rows) {
      this.$emit("update:refObj", this.$refs.multipleTable);
      this.$emit("handleEvent", "tableCheck", rows);
    },
    //
    toggleRowData() {
      this.$emit("update:refObj", this.$refs.multipleTable);
      //
      if (this.toggleRowSelections && this.data) {
        this.data.forEach((item, index) => {
          this.toggleRowSelections.forEach((items, indexs) => {
            if (this.data[index].id === this.toggleRowSelections[indexs]) {
              this.$refs.multipleTable.toggleRowSelection(this.data[index], true);
            } else if (
              this.data[index].pageOpId === this.toggleRowSelections[indexs]
            ) {
              this.$refs.multipleTable.toggleRowSelection(this.data[index], true);
            } else if (
              this.data[index].roleId === this.toggleRowSelections[indexs]
            ) {
              this.$refs.multipleTable.toggleRowSelection(this.data[index], true);
            }
          });
        });
      }
      //
    },
  },
};
</script>
<style>
.el-table__fixed, .el-table__fixed-right{
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/table.vue